
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hriste/[id]",
      function () {
        return require("private-next-pages/hriste/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hriste/[id]"])
      });
    }
  